/* eslint no-underscore-dangle: [error, { allow: [__REDUX_DEVTOOLS_EXTENSION__] }] */
import { createElement as ele } from 'react';
import { createRoot } from 'react-dom/client';
import {
  legacy_createStore as createStore,
  applyMiddleware,
  combineReducers,
  compose,
} from 'redux';
import thunk from 'redux-thunk';
import { Provider } from 'react-redux';
import { init } from '@sentry/browser';
import { startSessionReplayRecording } from './lib/datadogRum';
import config from './config';
import AppContainer from './containers/AppContainer';

if (config.appEnvironment !== 'local') {
  init({
    dsn: config.sentryDsn,
    environment: config.appEnvironment,
    release: config.version,
  });
}
const { useDevTool } = config;
const reducers = require('./reducers').default;

const getReducer = () => combineReducers({ ...reducers });

const store = createStore(
  getReducer(),
  compose(
    applyMiddleware(thunk),
    useDevTool && window.__REDUX_DEVTOOLS_EXTENSION__
      ? window.__REDUX_DEVTOOLS_EXTENSION__()
      : f => f,
  ),
);

const root = document.getElementById('root');
const renderApp = () => {
  startSessionReplayRecording();

  const rootReact = createRoot(root);
  rootReact.render(ele(Provider, { store }, ele(AppContainer)));
};
renderApp();
